import React, { PureComponent } from 'react';

class ApplicationInfo extends PureComponent {
  render() {
    const { application, schoolCodes } = this.props;
    if (!application) {
      return (
        <div className="placeholder">Click on a circle to view application details here</div>
      );
    } else {
      const d = application;
      let assignedLastChoice = false;
      return (
        <div className="info">
          <h2>Selected application</h2>
          <div className="application-detail grid">
            <span className="grid-label">Zip code:</span><span className="grid-item">{d.zip}</span>
            <span className="grid-label">From CTIP1 area?</span><span className="grid-item">{d.ctip}</span>
            <span className="grid-label">1st choice school:</span><span className="grid-item">{schoolCodes.get(d.schools[0]).name}</span>
            <span className="grid-label">Got 1st choice?</span><span className="grid-item">{d.assigned1stChoice} - {schoolCodes.get(d.assigned).name} (rank {d.assignedRank})</span>
            <span className="grid-label">Where enrolled?</span><span className="grid-item">{d.enrolledStatus === "Outside SFUSD" && "Outside SFUSD - "} {schoolCodes.has(d.enrolled) ? schoolCodes.get(d.enrolled).name : "unknown"} {d.enrolledRank > 0 && ' (rank ' + d.enrolledRank + ')'}</span>
          </div>
          <div className="school-list">
            {d.schools.map((school, index) => {
              const rank = index + 1;
              let symbol = '';
              let outcome = '';
              if (rank === d.assignedRank) {
                if (d.assignedRank === d.enrolledRank) {
                  symbol = '\u2713';
                  outcome = 'kept';
                } else {
                  symbol = '\u2715';
                  outcome = 'discarded';
                }
                if (rank === d.schools.length) {
                  assignedLastChoice = true;
                }
              } else if (rank === d.enrolledRank) {
                symbol = '\u2713';
                outcome = 'changed';
              }
              return (
                <div key={index} className={"grid " + outcome}>
                  <span className="grid-label">{symbol}</span><span className="grid-item">{rank + ". " + schoolCodes.get(school).name} {schoolCodes.get(school).citywide && " (citywide)"} { assignedLastChoice && (<sup>*</sup>)}</span>
                </div>
              );
            })}
            {assignedLastChoice && <div className="footnote"><sup>*</sup> May not have been in the original ranked list (see FAQ)</div>}
          </div>
        </div>
      );
    }
  }
}

export default ApplicationInfo;




// WEBPACK FOOTER //
// ./src/ApplicationInfo.js